import { Component, Input } from '@angular/core';
import { ErrorService } from 'src/app/core/error.service';
import { Store, StoresService } from 'src/app/core/stores.service';

@Component({
  selector: 'app-store-details-general',
  templateUrl: './store-details-general.component.html',
  styleUrls: ['./store-details-general.component.scss'],
})
export class StoreDetailsGeneralComponent {
  @Input() company_id?: string | null;
  @Input() store_id?: string | null;

  store?: Store;
  is_read_running = true;

  constructor(private stores_service: StoresService, private error_service: ErrorService) {}

  ngOnInit(): void {
    this.readStore(this.store_id as string);
  }

  onRefresh(): void {
    this.readStore(this.store_id as string);
  }

  readStore(store_id: string): void {
    this.is_read_running = true;
    this.stores_service.readStore(store_id).subscribe({
      next: response => {
        this.store = response.data;
        this.is_read_running = false;
      },
      error: error => {
        this.error_service.processGenericApiError(error);
        this.is_read_running = false;
      },
    });
  }
}
